import type { ReactNode } from 'react';
import { cx } from '../internal/cx';

export type BadgeIntent = 'neutral' | 'brand' | 'success' | 'warning' | 'danger' | 'info';

export type BadgeProps = {
  intent?: BadgeIntent;
  /** Halo pulsé (activité en direct, « X en ligne »…). */
  pulse?: boolean;
  children: ReactNode;
  className?: string;
};

const INTENTS: Record<BadgeIntent, string> = {
  neutral: 'bg-ink-100/10 text-ink-100 border-ink-600',
  brand: 'bg-panda-500/15 text-panda-400 border-panda-500/40',
  success: 'bg-bamboo-500/15 text-bamboo-400 border-bamboo-500/40',
  warning: 'bg-sun-500/15 text-sun-400 border-sun-500/40',
  danger: 'bg-danger-500/15 text-danger-500 border-danger-500/40',
  info: 'bg-sky-500/15 text-sky-400 border-sky-500/40',
};

/** Pastille d'état. Contrastes AA vérifiés sur les surfaces sombres/claires. */
export function Badge({ intent = 'neutral', pulse = false, children, className }: BadgeProps) {
  return (
    <span
      className={cx(
        'inline-flex items-center gap-1.5 rounded-full border px-2.5 py-0.5 text-xs font-semibold',
        INTENTS[intent],
        pulse && 'animate-pulse-soft',
        className,
      )}
    >
      {children}
    </span>
  );
}
